import Api from 'utils/api';
import { SET_MODULES, RESET_MODULES } from 'store/types/module';

export const resetModuleData = () => ({ type: RESET_MODULES });
export const setModules = modules => ({ type: SET_MODULES, payload: modules });

export const getModules = () =>
  Api.get('/modules', {
    params: { includeDisabled: true, include: ['moduleAssets', 'submodules'] }
  });
